import { createContext, useContext } from "react";
import { ApiStatus } from "src/hooks/api/utils/useApi";

export interface ListContextProps {
	data: any[];
	status?: ApiStatus;
	columnCount?: number;
}

export const ListContext = createContext<ListContextProps | undefined>(
	undefined
);

export function useList() {
	const props = useContext(ListContext);
	if (props === undefined) {
		throw new Error("useList must be used within a ListProvider");
	}

	return {
		...props,
		isEmpty: props.status === "idle" && props.data.length === 0,
	};
}
